import { render } from "./ClassesDetails.vue?vue&type=template&id=26b57e6b&scoped=true"
import script from "./ClassesDetails.vue?vue&type=script&lang=js"
export * from "./ClassesDetails.vue?vue&type=script&lang=js"

import "./ClassesDetails.vue?vue&type=style&index=0&id=26b57e6b&scoped=true&lang=css"
import "./ClassesDetails.vue?vue&type=style&index=1&id=26b57e6b&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b57e6b"]])

export default __exports__